import React from 'react';
import Slider from 'react-slick';
import '../assets/css/TestimonialCarousel.css'; // Optional: For custom styles
import 'slick-carousel/slick/slick.css';

import 'slick-carousel/slick/slick-theme.css';



const TestimonialCarousel = () => {
  const settings = {
    infinite: true,  // Enables infinite looping
    speed: 500,      // Transition speed (ms)
    slidesToShow: 3, // Number of slides to show at once
    slidesToScroll: 1, // Number of slides to scroll at once
    autoplay: true,  // Automatically slide at a regular interval
    autoplaySpeed: 3000, // Interval for autoplay (in ms)
    dots: false,      // Show navigation dots
    arrows: false,    // Show next and previous arrows
    centerMode: false, // Center the active slide
    focusOnSelect: false, // Focus on the selected slide
    responsive: [
      {
        breakpoint: 992,  // On smaller screens, show only 1 item
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,  // On smaller screens, show only 1 item
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section className="testimonial-section pt-5">
      <Slider {...settings}>
        <div className="testimonial-item">
          <div className="rating">
              <span>★ ★ ★ ★ ☆</span>
          </div>
          {/* <h4 className='testimonial-title'>Exceptional Craftsmanship</h4> */}
          <p className="testimonial-text">“Absolutely thrilled with their work on our kitchen remodel. The team was professional, efficient, and detail-oriented. Highly recommended!”</p>
          <div className="testi-inform">
          <div className='client-info'>
            <h5 className="client-name">Miguel sewney</h5>
          </div>
          </div>
        </div>
        <div className="testimonial-item">
          <div className="rating">
              <span>★ ★ ★ ★ ☆</span>
          </div>
          {/* <h4 className='testimonial-title'>Exceptional Craftsmanship</h4> */}
          <p className="testimonial-text">The exterior painting project was flawless. They transformed our home’s appearance and even cleaned up thoroughly after the job.</p>
          <div className="testi-inform">
          <div className='client-info'>
            <h5 className="client-name">Andrea Cassidy</h5>
          </div>
          </div>
        </div>
        <div className="testimonial-item">
          <div className="rating">
              <span>★ ★ ★ ★ ☆</span>
          </div>
          {/* <h4 className='testimonial-title'>Exceptional Craftsmanship</h4> */}
          <p className="testimonial-text">Excellent service from start to finish! They completed our roofing repair on time, and it looks amazing.</p>
          <div className="testi-inform">
          <div className='client-info'>
            <h5 className="client-name">Kerry coffman</h5>
          </div>
          </div>
        </div>
        <div className="testimonial-item">
          <div className="rating">
              <span>★ ★ ★ ★ ☆</span>
          </div>
          {/* <h4 className='testimonial-title'>Exceptional Craftsmanship</h4> */}
          <p className="testimonial-text">I’m so glad we chose V-Strong Contractor for our basement renovation. It’s now the perfect entertainment space!</p>
          <div className="testi-inform">
          <div className='client-info'>
            <h5 className="client-name">Ann stevenson</h5>
          </div>
          </div>
        </div>
        <div className="testimonial-item">
          <div className="rating">
              <span>★ ★ ★ ★ ☆</span>
          </div>
          {/* <h4 className='testimonial-title'>Exceptional Craftsmanship</h4> */}
          <p className="testimonial-text">Their siding installation gave our home a fresh new look, and the quality of work is top-notch.</p>
          <div className="testi-inform">
          <div className='client-info'>
            <h5 className="client-name">Kaytlen harbey</h5>
          </div>
          </div>
        </div>
        <div className="testimonial-item">
          <div className="rating">
              <span>★ ★ ★ ★ ☆</span>
          </div>
          {/* <h4 className='testimonial-title'>Exceptional Craftsmanship</h4> */}
          <p className="testimonial-text">Very professional and courteous team. They turned my outdated bathroom into a luxurious retreat.</p>
          <div className="testi-inform">
          <div className='client-info'>
            <h5 className="client-name">Hitesh pattnam</h5>
          </div>
          </div>
        </div>
        
       
        {/* Add more testimonial items here */}
      </Slider>
    </section>
  );
};

export default TestimonialCarousel;
